import { Injectable } from '@angular/core';
import { FloorClass } from '../../../models/floor.class';
import { ElevatorBank } from '../../stacking-plan.model';
import { EDPElevatorBank, ElevatorBankProcessed } from './elevator-banks.model';
import { ElevatorBanksMatrixAdapter } from './elevator-banks-matrix-adapter.service';
import { ElevatorBanksAdapter } from './elevator-banks-adapter.service';

@Injectable()
export class ElevatorBanksRepository {
  #elevatorBanksMatrix: ElevatorBankProcessed[][] = [];
  #edpElevatorBank: EDPElevatorBank[] = [];
  #elevatorBank: ElevatorBank[] = [];
  #elevatorsMatrixAdapter = new ElevatorBanksMatrixAdapter();
  #elevatorBanksAdapter = new ElevatorBanksAdapter();

  set(elevatorData: EDPElevatorBank[], floors: FloorClass[]) {
    this.#edpElevatorBank = elevatorData;
    this.#elevatorBanksMatrix = this.#elevatorsMatrixAdapter.adapt(floors, elevatorData);
    this.#elevatorBank = this.#elevatorBanksAdapter.adapt(elevatorData);
  }

  setElevatorBanks(elevatorBank: ElevatorBank[]) {
    this.#elevatorBank = elevatorBank;
  }

  get elevatorBanks() {
    return this.#elevatorBank;
  }

  get edpElevatorBanks() {
    return this.#edpElevatorBank;
  }

  get elevatorBanksMatrix() {
    return this.#elevatorBanksMatrix;
  }

  reset() {
    this.#elevatorBanksMatrix = [];
    this.#edpElevatorBank = [];
    this.#elevatorBank = [];
  }
}
